document.querySelectorAll('.mc-editorial-source').forEach(root => {
  root.querySelectorAll('tab-collage').forEach(collage => {
    const tabs = [...collage.querySelectorAll('.tab-collage__heading[data-block-id]')];
    const cards = [...collage.querySelectorAll('.tab-collage__card[data-block-id],.tab-collage__desc[data-block-id]')];
    const select = tab => {
      tabs.forEach(item => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      cards.forEach(card => card.classList.toggle('is-active', card.dataset.blockId === tab.dataset.blockId));
    };
    tabs.forEach(tab => {
      tab.setAttribute('role', 'button');
      tab.tabIndex = 0;
      tab.setAttribute('aria-pressed', String(tab.classList.contains('is-active')));
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', event => {
        if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); select(tab); }
      });
    });
  });
  root.querySelectorAll('.tabs-grid').forEach(group => {
    const tabs = [...group.querySelectorAll('details')];
    tabs.forEach(tab => tab.addEventListener('toggle', () => {
      if (tab.open) tabs.forEach(other => { if (other !== tab) other.open = false; });
    }));
  });
  root.querySelectorAll('video').forEach(video => { video.controls = true; video.load(); });
});
